class StickyFilterBar {
    constructor() {
        this.options = {
            filtersWrapperSelector: '#main-collection-filters-wrapper',
            filtersHiddenClassName: 'filters-wrapper--hidden',
            filtersFixedClassName: 'filters-wrapper--fixed',
            desktopHeaderHeightVarName: '--header-desktop-height',
            mobileHeaderHeightVarName: '--header-mobile-height'
        };

        this.headerHeight = 0;
        this.lastScrollY = 0;

        this.init();
    }

    init() {
        this.defineHeaderHeight();
        this.addScrollListener();
    }

    addScrollListener() {
        window.addEventListener("scroll", () => this.handleScroll());
    }

    defineHeaderHeight() {
        const headerMobileHeight = getComputedStyle(document.documentElement).getPropertyValue(this.options.mobileHeaderHeightVarName);
        const headerDesktopHeight = getComputedStyle(document.documentElement).getPropertyValue(this.options.desktopHeaderHeightVarName);
    
        const headerHeight = window.matchMedia("(max-width: 767px)").matches
            ? parseInt(headerMobileHeight)
            : parseInt(headerDesktopHeight);

        this.headerHeight = headerHeight
    }

    handleScroll() {
        const filtersWrapper = document.querySelector(this.options.filtersWrapperSelector);
        if (!filtersWrapper) return;

        const filtersWrapperTop = filtersWrapper.getBoundingClientRect().top;
        const currentScrollY = window.scrollY;
        
        if (currentScrollY > this.lastScrollY) {
            filtersWrapper.classList.add(this.options.filtersHiddenClassName);
        } else {
            filtersWrapper.classList.remove(this.options.filtersHiddenClassName);
        }

        this.lastScrollY = currentScrollY;

        if (filtersWrapperTop <= this.headerHeight) {
            filtersWrapper.classList.add(this.options.filtersFixedClassName);
        } else {
            filtersWrapper.classList.remove(this.options.filtersFixedClassName);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new StickyFilterBar());
